import React from 'react';

import { appColors } from '../../config/colors';
import { ITooltip } from '../../types.DrawIt';

interface TooltipProps {
    tooltip: ITooltip;
}

export const Tooltip: React.FC<TooltipProps> = ({ tooltip }) => {
    return (
        <g
            className="tooltip"
            transform={`translate(${tooltip.x}, ${tooltip.y})`}
            style={{
                opacity: tooltip.isOpen ? '1' : '0',
                transition: 'opacity 250ms ease',
                filter: 'drop-shadow(2.5px 2.5px 5px rgba(0, 0, 0, .5))',
                WebkitFilter: 'drop-shadow(2.5px 2.5px 5px rgba(0, 0, 0, .5))'
            }}
        >
            <rect width={tooltip.width} height={tooltip.height} rx="5" ry="5" fill="white" />
            <polygon
                fill="white"
                points={`${tooltip.width * 0.4},${tooltip.height - 1} ${tooltip.width / 2},${tooltip.height *
                    1.25} ${tooltip.width * 0.6},${tooltip.height - 1}`}
            />
            {tooltip.label && (
                <>
                    <text
                        fontSize="14"
                        fill={appColors.fontSecondary}
                        x={tooltip.width / 2}
                        y={tooltip.height / 2}
                        dy="-0.25em"
                        textAnchor="middle"
                    >
                        {tooltip.label.text}
                    </text>
                    <text fontSize="14" x={tooltip.width / 2} y={tooltip.height / 2} dy="1em" textAnchor="middle">
                        {tooltip.label.parties?.map((party, index) => (
                            <React.Fragment key={`party-${party}`}>
                                <tspan fill={tooltip.label?.colors[index]} dx={index > 0 ? '0.25em' : 0}>
                                    {party}
                                </tspan>{' '}
                                {index > 0 ? '' : '/'}
                            </React.Fragment>
                        ))}
                    </text>
                </>
            )}
        </g>
    );
};
